/**
 * Created by Ning Jiang on 2024-08-29.
 */

import {WinPresentationController} from "../WinPresentationController";
import {ElGordosRevenge} from "../../ElGordosRevenge";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {TimelineLite, TweenLite} from "gsap";
import {ElGordosRevengeGameAssets} from "../../ElGordosRevengeGameAssets";
import {ElGordosRevengeLayers, Layers} from "../../view/ElGordosRevengeLayers";
import {AnimatedMeshRope} from "../../../core/components/AnimatedMeshRope";
import {ElGordosRevengeGameConfig} from "../../ElGordosRevengeGameConfig";
import {EGRBonusSymbol} from "../../symbol/EGRBonusSymbol";
import {ElGordosRevengeSound} from "../../sound/ElGordosRevengeSound";

export class CollectBonusController extends WinPresentationController {

    constructor() {
        super("CollectBonusController", false);

        // Restore BN symbol views
        if(ElGordosRevenge.model.isRestore) {
            ElGordosRevenge.model.parsedInitData.BNPositions.forEach(positions => {
                const symbol = <EGRBonusSymbol>ElGordosRevenge.reels[positions[0]].getSymbol(positions[1]);
                // hide used BN symbols.
                symbol.playAfterCollect(true);
            });
        }
    }

    protected hasWin():boolean {
        if(!ElGordosRevenge.model.parsedGameData.mode.includes(GameMode.FREESPIN)) {
            return false;
        }
        return ElGordosRevenge.model.parsedGameData.BNPositions.length > 0;
    }

    protected async createWinAnimation():Promise<any> {
        const tl = new TimelineLite();
        const multiTexts:PIXI.BitmapText[] = [];
        const fsTexts:PIXI.Container[] = [];
        ElGordosRevenge.model.parsedGameData.BNPositions.forEach(positions => {
            const symbol = <EGRBonusSymbol>ElGordosRevenge.reels[positions[0]].getSymbol(positions[1]);
            const symbolGlobalPosition = symbol.getGlobalCenterPosition();
            const fsContainer = new PIXI.Container();
            const plus = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures("freespin/+")[0]);
            plus.anchor.set(0, 0.5);
            plus.scale.set(0.36);
            const fsText = new PIXI.BitmapText("1", {
                fontName : ElGordosRevengeGameAssets.BITMAP_FONT_FREESPIN_NUMBER,
                fontSize : 8,
                tint : 0xffffff
            });
            (<PIXI.Point>fsText.anchor).set(0, 2.2);
            const fsImage = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures("freespin/+1FS")[0]);
            fsImage.anchor.set(1, 0.5);
            fsImage.scale.set(0.6, 0.7);
            fsContainer.addChild(plus, fsImage, fsText);
            const fsWidth = plus.width + fsText.textWidth + fsImage.width + 2;
            plus.x = -fsWidth * 0.5
            fsText.x = plus.x + plus.width;
            fsImage.x = fsWidth * 0.5;
            fsContainer.position.set(symbolGlobalPosition.x, symbolGlobalPosition.y - 20);
            fsTexts.push(fsContainer);
            const multiText = new PIXI.BitmapText("+x1", {
                fontName : ElGordosRevengeGameAssets.BITMAP_FONT_NUDGE_MULTIPLIER,
                fontSize : 25,
                tint : ElGordosRevengeGameConfig.MULTIPLIER_TEXT_TINT
            });
            multiText.letterSpacing = -10;
            (<PIXI.Point>multiText.anchor).set(0.5, 1.38);
            multiText.scale.y = 0.7;
            multiText.position.set(symbolGlobalPosition.x, symbolGlobalPosition.y + 40);
            multiTexts.push(multiText);
            const symbolTl = new TimelineLite();
            symbolTl.add(symbol.playCollect());
            symbolTl.add(CollectBonusController.playSwoosh(new PIXI.Point(symbolGlobalPosition.x, symbolGlobalPosition.y + 30), ElGordosRevenge.fsMeter.getNextStepGlobalPosition()));
            symbolTl.add([
                () => {
                    fsContainer.alpha = 0;
                    multiText.alpha = 0;
                    ElGordosRevengeLayers.getLayer(Layers.METER_EFFECTS)!.addChild(fsContainer);
                    ElGordosRevengeLayers.getLayer(Layers.METER_EFFECTS)!.addChild(multiText);
                },
                TweenLite.to(fsContainer, 0.3, {alpha : 1}),
                TweenLite.to(multiText, 0.3, {alpha : 1}),
                ElGordosRevenge.fsMeter.addSteps(1, true)
            ], `-=0.2`);
            tl.add(symbolTl);
        });

        // add extra fs
        tl.add(ElGordosRevenge.fsMeter.addBNFSLeft(fsTexts));

        // add multi
        let firstMulti:boolean = true;
        multiTexts.forEach(multiText => {
            tl.add(ElGordosRevenge.fsMeter.addBNMultipliers(multiText), `-=${firstMulti ? 0.2 : 0.5}`);
            firstMulti = false;
        });
        tl.add(() => {}, `+=0.01`); // temp, give time for multiplier to update. later animate it.
        multiTexts.length = 0;
        fsTexts.length = 0;
        return Promise.resolve(tl);
    }

    public static playSwoosh(from:PIXI.Point, to:PIXI.Point):TimelineLite {
        const pointsData = [
            {x : from.x, y : from.y},
            {x : from.x, y : from.y},
            {x : to.x, y : to.y},
            {x : to.x, y : to.y}
        ];
        const swoosh = new AnimatedMeshRope(ElGordosRevenge.assetLoader.getTextures('animJpeg/meterSwoosh/meterSwoosh_'),
            pointsData, 60);
        swoosh.blendMode = PIXI.BLEND_MODES.ADD;

        const tl = new TimelineLite();
        tl.add([
            () => {
                ElGordosRevengeLayers.getLayer(Layers.METER_EFFECTS)!.addChild(swoosh);
                ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.BONUS_SWOOSH});
            },
            swoosh.playAnimation()
        ]);
        // tl.add(() => {debugger;});
        return tl;
    }
}